import { IValidationErrorData } from '../../../../../../common/error/IValidationErrorData';
import { injectEntity } from '../../../../../../common/store/base/injectEntity';
import { injectEntityList } from '../../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../../common/store/base/injectPrimitive';
import { IEntityListStore } from '../../../../../../common/store/interface/IEntityListStore';
import { IEntityStore } from '../../../../../../common/store/interface/IEntityStore';
import { IPrimitiveStore } from '../../../../../../common/store/interface/IPrimitiveStore';
import {
  IApplicationDataChatCounterModel,
} from '../../../../../../service/application/data/IApplicationDataChatCounterModel';
import { IApplicationDataModel } from '../../../../../../service/application/data/IApplicationDataModel';
import {
  ApplicationAcceptStatus,
  IApplicationModel,
} from '../../../../../../service/application/entity/IApplicationModel';
import { getServerNowDate } from '../../../../../../service/date/since';
import { IPerformerTypeModel } from '../../../../../../service/performer/type/IPerformerTypeModel';
import { IProjectModel } from '../../../../../../service/project/IProjectModel';
import { IUserProjectRoleModel } from '../../../../../../service/projectRole/entity/IUserProjectRoleModel';
import {
  ISpecificationCategoryModel,
} from '../../../../../../service/specification/category/ISpecificationCategoryModel';
import { ISpecificationEntityModel } from '../../../../../../service/specification/entity/ISpecificationEntityModel';
import { IUnitModel } from '../../../../../../service/unit/interface/IUnitModel';
import { IUnitResultModel } from '../../../../../../service/unitResult/IUnitResultModel';
// import { IUserEntityModel } from '../../../../../../service/user/IUserEntityModel';
import { IGroupedUnit } from '../../../../../admin/page/unitListPage/store/IGroupedUnit';
import { LearningApplicationInfoPage } from '../../../../applicationInfo/LearningApplicationInfoPage';
import { ApplicationInfoDetails } from '../parts/application/ApplicationInfoDetails';
import { ApplicationDetailDomain } from './ApplicationDetailDomain';
import { ApplicationDetailsMode } from './ApplicationDetailsMode';
import { ApplicationDetailsType } from './ApplicationDetailsType';
import { ConfigManager } from '../../../../../../application/config/ConfigManager';

export const Version = {
  major: 'major',
  minor: 'minor',
  patch: 'patch'
}

export const ApplicationStatuses = {
  review: 'на проверке',
  draft: 'черновик',
}

export const defaultEditApplication = {};

export class ApplicationDetailUI {
  constructor(
    public isLoading: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    public isCompletePageStartLoading: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    public isFirstBootLoaded = injectPrimitive<boolean>(false),
    public mode: IPrimitiveStore<ApplicationDetailsMode> = injectPrimitive<ApplicationDetailsMode>(
      ApplicationDetailsMode.view,
    ),
    public type: IPrimitiveStore<ApplicationDetailsType> = injectPrimitive<ApplicationDetailsType>(
      ApplicationDetailsType.entity,
    ),
    // public isCanSeeRegulators: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    public isCanUpdate: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    // public isCanEditRequirementRemarks: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    public isAdmin: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    public isCanDelete: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    public isCanCreate: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    // public isAdminAccess: IPrimitiveStore<boolean> = injectPrimitive<boolean>(false),
    // public activeUserId: IPrimitiveStore<string> = injectPrimitive<string>(''),
    // public activeUserProjectRoleId: IPrimitiveStore<string> = injectPrimitive<string>(''),
    public project: IEntityStore<IProjectModel> = injectEntity<IProjectModel>({}),
    public application: IEntityStore<IApplicationModel> = injectEntity<IApplicationModel>({}),
    public applicationData: IEntityStore<IApplicationDataModel> = injectEntity<IApplicationDataModel>({}),
    // public previewApplicationData: IEntityStore<IApplicationDataModel> = injectEntity<IApplicationDataModel>({}),
    public applicationSpecifications: IEntityListStore<ISpecificationEntityModel> = injectEntityList<ISpecificationEntityModel>(
      [],
    ),
    public applicationSpecificationsCategories: IEntityListStore<ISpecificationCategoryModel> = injectEntityList<ISpecificationCategoryModel>(
      [],
    ),
    public applicationPerformerType: IEntityStore<IPerformerTypeModel> = injectEntity<IPerformerTypeModel>({}),
    public editPerformerTypes: IEntityListStore<IPerformerTypeModel> = injectEntityList<IPerformerTypeModel>([]),
    public editSpecifications: IEntityListStore<ISpecificationEntityModel> = injectEntityList<ISpecificationEntityModel>(
      [],
    ),
    public editSpecificationsCategories: IEntityListStore<ISpecificationCategoryModel> = injectEntityList<ISpecificationCategoryModel>(
      [],
    ),
    // public editUsers: IEntityListStore<IUserEntityModel> = injectEntityList<IUserEntityModel>([]),
    public editApplication: IEntityStore<IApplicationModel> = injectEntity<IApplicationModel>(defaultEditApplication),
    public applicationValidationErrors = injectEntityList<IValidationErrorData>([]),
    public specificationsTextFieldsErrors = injectPrimitive<any[]>([]),
    public specificationsTextFieldsValues = injectEntityList<ISpecificationEntityModel>([]),
    // public userProjectRoleActions = injectPrimitive<string[]>([]),
    public allProjectRoles = injectPrimitive<IUserProjectRoleModel[]>([]),
    public applicationNewMessagesState = injectPrimitive<IApplicationDataChatCounterModel | null>(null),
    public isDisabledSaveButton = injectPrimitive<boolean>(false),
    // public isSetDefaultTemplate = injectPrimitive<boolean>(false),
    public learningUnitList = injectEntityList<IUnitModel>([]),
    public learningPassingList = injectEntityList<IUnitModel>([]),
    public learningCharacteristicList = injectEntityList<ISpecificationEntityModel>([]),
    public learningSpecificationCategory: IEntityListStore<ISpecificationCategoryModel> = injectEntityList([]),
    public learningTeamUserIds = injectEntityList<string>([]),
    public learningRoleFilterIds = injectEntityList<string>([]),
    public learningRolesWithUnits = injectEntityList<{ roleId: string; name: string }>([]),
    public learningIsShowWarning = injectPrimitive<boolean>(false),
    public learningApplicationSpecificationsSet = injectPrimitive<Set<string>>(new Set()),
    public learningGroupedUnits: IEntityListStore<IGroupedUnit> = injectEntityList([]),
    public learningPassingResultList = injectEntityList<IUnitResultModel>([]),
    public learningIsLoading = injectPrimitive<boolean>(false),
    public tabsData = injectPrimitive<{
      state: number;
      defaultViewKey: string;
      tabs: {
        key: string;
        Component: any;
        isShow?: (domain: ApplicationDetailDomain) => boolean;
        getTitle: (domain: ApplicationDetailDomain, translate?: any) => string;
      }[];
    }>({
      state: 0,
      defaultViewKey: 'form',
      tabs: [
        {
          key: 'form',
          Component: ApplicationInfoDetails,
          getTitle: (domain: ApplicationDetailDomain, translate) => translate('projectPage.profile'),
        },
        {
          key: 'learning',
          Component: LearningApplicationInfoPage,
          getTitle: (domain: ApplicationDetailDomain, translate) =>
            domain.ui.mode.value === ApplicationDetailsMode.view
              ? translate('projectPage.training')
              : translate('projectPage.trainingPreview'),
        },
      ],
    }),
  ) {
  }

  changeTab(key: string) {
    const index = this.tabsData.value.tabs.findIndex((item) => item.key === key);
    if (index !== -1) {
      this.tabsData.value.state = index;
    }
  }

  getRequirementCount(translate) {
    if (!this.applicationData.entity.requirementCount) {
      return `${translate('projectPage.requirements')} (0)`;
    }

    return `${translate('projectPage.requirements')} (${this.applicationData.entity.requirementCount})`;
  }

  private getVersionFromNumber({ versionType, version }: { versionType: {}, version?: string }) {
    if (versionType === Version.major) {
      return version?.split('.').slice(0, 1).join('.') || '';
    } else if (versionType === Version.minor) {
      return version?.split('.').slice(0, 2).join('.') || '';
    } else if (versionType === Version.patch) {
      return version?.split('.').slice(0, 3).join('.') || '';
    }
    return '';
  }

  getVersionWithStatus(
    { versionType, application }: { versionType: {}, application?: IApplicationModel }
      = { versionType: Version.patch },
  ): string {
    let statusText = '';
    let version = this.getVersion({ versionType });
    let acceptStatus = this.application.entity.acceptStatus;
    const lastVersion = this.application.entity.versionNumber;

    if (application) {
      version = this.getVersionFromNumber({ version: application.versionNumber, versionType });
    }

    // Если есть application - то это кнопка на вкладке истории изменений
    // else для случая, когда у нас основная сущность не завершена
    if (
      acceptStatus && !application &&
      acceptStatus !== ApplicationAcceptStatus.accepted
    ) {
      statusText = ` (${ApplicationStatuses[acceptStatus]})`;
      const splitVersion = version.split('.');
      splitVersion[0] = String(Number(splitVersion[0]) + 1);
      splitVersion[1] = '0';
      version = splitVersion.join('.');
    }
    // else if (
    //   acceptStatus && application &&
    //   acceptStatus !== ApplicationAcceptStatus.accepted &&
    //   application.versionNumber?.split('.')[0] === lastVersion?.split('.')[0] &&
    //   application.versionNumber?.split('.')[1] === lastVersion?.split('.')[1]
    // ) {
    //   console.log(application.versionNumber, lastVersion, 234234)
    //   statusText = ` (${ApplicationStatuses[acceptStatus]})`;
    // }

    return `${version}${statusText}`;
  }

  getVersion({ versionType }: { versionType?: any }): string {
    const fullVersion = this.application?.entity?.versionNumber?.split('.');

    if (versionType === Version.major) {
      return fullVersion?.splice(0, 1).join('.') || '';
    } else if (versionType === Version.minor) {
      return fullVersion?.splice(0, 2).join('.') || '';
    } else if (versionType === Version.patch) {
      return fullVersion?.splice(0, 3).join('.') || '';
    }
    return '';
  }

  getVersionOrStatus(versionType = Version.major) {
    const version = this.getVersion({ versionType });
    if (ConfigManager.getConfig().ui.application.acceptWithVersion) {
      if (this.application?.entity?.name && this.application?.entity?.name?.length > 0) {
        if (this.application?.entity?.acceptStatus === ApplicationAcceptStatus.draft) {
          return ` (${ApplicationStatuses.draft})`;
        }
        if (this.application?.entity?.acceptStatus === ApplicationAcceptStatus.review) {
          return ` (${ApplicationStatuses.review})`;
        }
        if (this.application?.entity?.acceptStatus === ApplicationAcceptStatus.accepted) {
          const fullVersion = this.application?.entity?.versionNumber?.split('.');
          if (fullVersion) {
            return ` ${version}`;
          } else {
            return ` ${this.application?.entity?.versionNumber}`;
          }
        }
      }
    }
    return '';
  }

  getAcceptStatusName(versionType = Version.minor) {
    if (ConfigManager.getConfig().ui.application.acceptWithVersion) {
      if (this.application?.entity?.name && this.application?.entity?.name?.length > 0) {
        if (this.application?.entity?.acceptStatus === ApplicationAcceptStatus.draft) {
          return ` (${ApplicationStatuses.draft}) `;
        }
        if (this.application?.entity?.acceptStatus === ApplicationAcceptStatus.review) {
          return ` (${ApplicationStatuses.review}) `;
        }
        if (this.application?.entity?.acceptStatus === ApplicationAcceptStatus.accepted) {
          const fullVersion = this.application?.entity?.versionNumber?.split('.');
          if (fullVersion) {
            return ` (версия ${this.getVersion({ versionType: versionType })}) `;
          } else {
            return ` (версия ${this.application?.entity?.versionNumber}) `;
          }
        }
      }
    }
    return '';
  }

  removeSelection = (): void => {};

  specificationsAutocompleteValues(categoryId?: string | null): any {
    return this.editSpecifications.list
      .filter((entity) => {
        return entity.categoryId === categoryId;
      })
      .map((entity) => ({ value: entity.id, name: entity.name }));
  }

  specificationsByCategoryId(categoryId?: string | null): ISpecificationCategoryModel[] {
    return this.applicationSpecifications.list.filter((entity) => entity.categoryId === categoryId);
  }

  performerTypesAutocompleteValues(): { value: any; name: any }[] {
    return this.editPerformerTypes.list.map((entity) => ({
      value: entity.id,
      name: entity.name,
    }));
  }

  applicationTemplateAutocompleteValues(): any {
    return [];
  }
}
